<template>
  <label
    :class="`Form__label Form__label--${cleanLabel}`"
    :for="cleanLabel"
  >
    <span class='Form__label-text'>{{ label }}</span>
    <abbr class="Form__label-required" title="required" v-if="required">*</abbr>
  </label>
</template>

<script>
export default {
  name: 'FormLabel',
  props: {
    cleanLabel: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormLabel.vue?2c6ca31c